import React from 'react';
import Navegation from './Navegation';
import '../styles/Header&Footer.css';

function Header() {
  return (
    <header className="header">
      <Navegation />
    </header>
  );
}

export default Header;
